(() => {
  const popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;
  const storageKey = 'offline-era-newsletter-popup-dismissed';
  const closeButtons = popup.querySelectorAll('[data-newsletter-close]');
  const firstField = popup.querySelector('input[type="email"]');
  const open = () => {
    popup.hidden = false;
    document.body.classList.add('newsletter-popup-open');
    window.setTimeout(() => firstField?.focus(), 80);
  };
  const close = (remember = true) => {
    popup.hidden = true;
    document.body.classList.remove('newsletter-popup-open');
    if (remember) localStorage.setItem(storageKey, 'true');
  };
  document.querySelectorAll('[data-newsletter-open]').forEach((button) => button.addEventListener('click', open));
  closeButtons.forEach((button) => button.addEventListener('click', () => close()));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) close();
  });
  if (popup.dataset.success === 'true') {
    open();
    localStorage.setItem(storageKey, 'true');
  } else if (!localStorage.getItem(storageKey)) {
    window.setTimeout(open, Number(popup.dataset.delay || 8000));
  }
})();
